import { templates as templates_task } from "./framework/freesia-design-task";
import { templates as templates_log } from "./framework/freesia-design-log";
// import templates_log from "./framework/freesia-design-log/templates";
import templates_message from "./framework/freesia-design-message/templates";
import templates_openapi from "./framework/freesia-design-openapi/templates";

import { templates as templates_mobile } from "./framework/freesia-design-mobile";
import { templates as templates_authentication } from "./framework/freesia-design-mobile-authentication";
import { templates as templates_mobile_messages } from "./framework/freesia-design-mobile-message";

import Echo from "./components/pages/Echo";
import SendNotifyToMe from "./components/addons/SendNotifyToMe";
import LoadDataBeforeRender from "./components/addons/LoadDataBeforeRender";

import IconTodo from "./components/addons/IconTodo";
import IconTodoSelected from "./components/addons/IconTodoSelected";
import IconGallery from "./components/addons/IconGallery";
import IconGallerySelected from "./components/addons/IconGallerySelected";
import IconMine from "./components/addons/IconMine";
import IconMineSelected from "./components/addons/IconMineSelected";

import PlotDesignerPage from "./components/pages/Tests/PlotDesignerPage";

const templates = [

    ...templates_task,
    ...templates_log,
    ...templates_message,
    ...templates_openapi,

    ...templates_mobile,
    ...templates_authentication,
    ...templates_mobile_messages,

    {
        name: "echo",
        // loader: () => import("./components/pages/Echo"),
        Component: Echo,
    },

    {
        name: "send-notify-to-me",
        Component: SendNotifyToMe,
        pure: true,
    },

    {
        name: "load-data-before-render",
        Component: LoadDataBeforeRender,
        pure: true,
    },

    {
        name: "intro",
        loader: () => import("./components/pages/Intro"),
    },
    {
        name: "helloworld",
        loader: () => import("./components/pages/QuickStart/Helloworld"),
    },
    {
        name: "changetheme",
        loader: () => import("./components/pages/QuickStart/ChangeTheme"),
    },
    {
        name: "newpage",
        loader: () => import("./components/pages/QuickStart/NewPage"),
    },
    {
        name: "newpage/dashboard",
        loader: () => import("./components/pages/QuickStart/NewPage/Dashboard"),
    },
    {
        name: "changecontenttheme",
        loader: () => import("./components/pages/QuickStart/ChangeContentTheme"),
    },
    {
        name: "needlogin",
        loader: () => import("./components/pages/QuickStart/NeedLogin"),
    },
    {
        name: "needlogin/dashboard",
        loader: () => import("./components/pages/QuickStart/NeedLogin/Dashboard"),
    },
    {
        name: "changerootroutepath",
        loader: () => import("./components/pages/QuickStart/ChangeRootRoutePath"),
    },
    {
        name: "usestaticresources",
        loader: () => import("./components/pages/QuickStart/UseStaticResources"),
    },
    {
        name: "usethemestyle",
        loader: () => import("./components/pages/QuickStart/UseThemeStyle"),
    },
    {
        name: "routepermission",
        loader: () => import("./components/pages/QuickStart/RoutePermission"),
    },


    {
        name: "samples/intro",
        loader: () => import("./components/pages/Samples/Intro"),
    },
    {
        name: "samples/pro-card",
        loader: () => import("./components/pages/Samples/ProCard"),
    },
    {
        name: "samples/dashboard/monitor",
        loader: () => import("./components/pages/Samples/Dashboard/Monitor"),
    },













    {
        name: "tests/propertygridkv",
        loader: () => import("./components/pages/Tests/PropertyGridKv"),
    },
    {
        name: "tests/propertygridform",
        loader: () => import("./components/pages/Tests/PropertyGridForm"),
    },
    {
        name: "tests/datascreenpage",
        loader: () => import("./components/pages/Tests/DataScreenPage"),
    },
    {
        name: "tests/plotdesignerpage",
        Component: PlotDesignerPage,
    },









    {
        name: "icons/todo",
        // loader: () => import("./components/pages/Echo"),
        Component: IconTodo,
        pure: true,
    },
    {
        name: "icons/todo-selected",
        // loader: () => import("./components/pages/Echo"),
        Component: IconTodoSelected,
        pure: true,
    },
    {
        name: "icons/gallery",
        // loader: () => import("./components/pages/Echo"),
        Component: IconGallery,
        pure: true,
    },
    {
        name: "icons/gallery-selected",
        // loader: () => import("./components/pages/Echo"),
        Component: IconGallerySelected,
        pure: true,
    },
    {
        name: "icons/mine",
        // loader: () => import("./components/pages/Echo"),
        Component: IconMine,
        pure: true,
    },
    {
        name: "icons/mine-selected",
        // loader: () => import("./components/pages/Echo"),
        Component: IconMineSelected,
        pure: true,
    },
]

export default templates;